import { supabase } from "@/integrations/supabase/client";

// Entities that always trigger audit logging on export
const AUDITED_ENTITIES = new Set([
  "invoices",
  "bills",
  "expenses",
  "vendors",
  "approvals",
]);

export async function logExport(params: {
  entityType: string;
  exportType: "csv" | "excel" | "pdf" | "print";
  recordCount: number;
  filters?: string;
}) {
  // Only audit sensitive / financial entities
  if (!AUDITED_ENTITIES.has(params.entityType)) return;

  try {
    const { data: companyId } = await supabase.rpc("my_company_id");
    if (!companyId) return;

    await (supabase.from("ops_audit_log") as any).insert({
      table_name: params.entityType,
      record_id: "00000000-0000-0000-0000-000000000000",
      action: `export_${params.exportType}`,
      old_status: null,
      new_status: null,
      metadata: {
        count: params.recordCount,
        filters: params.filters ?? null,
        export_type: params.exportType,
      },
      company_id: companyId,
    } as any);
  } catch {
    // Audit logging is best-effort — don't block the export
  }
}
